import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/fonts.css';
import './styles/tokens.css';
import './styles/base.css';
import { App } from './App';
import { LocaleProvider } from './i18n/LocaleProvider';
import { captureProvenance } from './lib/provenance';

/*
 * Before React mounts, and before anything can navigate. The router replaces the
 * whole URL on a route change, query string included, so the campaign that
 * produced this visit is only readable in these first milliseconds.
 */
captureProvenance();

const container = document.getElementById('root');
if (!container) throw new Error('Root container #root not found');

createRoot(container).render(
  <StrictMode>
    <LocaleProvider>
      <App />
    </LocaleProvider>
  </StrictMode>,
);
